export default function(esinp, exp) {
  return (Math.pow((1 - esinp) / (1 + esinp), exp));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/srat.js
// module id = 111
// module chunks = 4